// extracted by mini-css-extract-plugin
export default {"wrapper":"EventPrivacyPolicy_wrapper__FqT4N","l-site-event":"EventPrivacyPolicy_l-site-event__VzeVQ","l-site-course":"EventPrivacyPolicy_l-site-course__A7q23"};